export function Terms() {
  return (
    <div className="mx-auto max-w-3xl px-4 py-16 sm:px-6">
      <h1 className="text-3xl font-bold tracking-tight text-text-primary">Terms of Service</h1>
      <p className="mt-2 text-sm text-text-muted">Last updated: {new Date().getFullYear()}</p>
      <div className="mt-8 space-y-6 text-sm leading-relaxed text-text-secondary">
        <Section title="Acceptance">
          By using Visiward you agree to these terms. This is an MVP document and not legal advice.
        </Section>
        <Section title="Service description">
          Visiward analyzes how your website and brand may be represented in AI-generated answers.
          Results are based on AI-generated answer analysis and are estimates. Visiward does not
          claim to directly collect live data from every external AI platform.
        </Section>
        <Section title="Launch-free access">
          The product is temporarily free during the launch period. Usage limits apply and may
          change. We may introduce paid plans in the future.
        </Section>
        <Section title="Acceptable use">
          You agree not to abuse the service, attempt to bypass usage limits or security controls,
          or analyze websites you are not authorized to submit.
        </Section>
        <Section title="No warranty">
          The service is provided “as is” without warranties. Visibility scores and recommendations
          are informational and do not guarantee outcomes.
        </Section>
        <Section title="Contact">Questions about these terms? Use the contact form.</Section>
      </div>
    </div>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <section>
      <h2 className="mb-2 text-lg font-semibold text-text-primary">{title}</h2>
      <p>{children}</p>
    </section>
  );
}
